import React from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import SegmentsIndex from 'components/SegmentsIndex';
import SegmentsEdit from 'components/SegmentsEdit';
import SegmentsView from 'components/SegmentsView';

import { ACCOUNT_PERMISSIONS } from 'constants/accountManagement/permissions';
import { selectUserRole } from 'reducers/account/users';
import { selectUserId } from 'reducers/user';
import { selectAccountFeature } from 'reducers/account/features';
import { USER_LISTS_SEGMENTS } from 'constants/features';

const BASE_PATH = '/segments';

const Segments = ({
  match: { path = BASE_PATH } = {},
  hasUserListsSegments,
}) => {
  const userId = useSelector(selectUserId);
  const role = useSelector(state => selectUserRole(state, userId));
  const canEditSegments = role !== ACCOUNT_PERMISSIONS.EDITOR;

  return (
    <Switch>
      {hasUserListsSegments && (
        <Redirect exact from="/segments" to="/audience/segments" />
      )}
      <Route path={`${path}/:segmentId/view`} component={SegmentsView} />
      {canEditSegments && (
        <Route path={`${path}/:segmentId/edit`} component={SegmentsEdit} />
      )}
      <Route path={path} component={SegmentsIndex} />
    </Switch>
  );
};

Segments.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string,
  }),
};

const mapStateToProps = state => ({
  hasUserListsSegments: selectAccountFeature(state, USER_LISTS_SEGMENTS),
});

export default connect(mapStateToProps)(Segments);
